import { Box, Typography } from '@mui/material';
import React from 'react';
import whattodo from '../../assets/images/Frame 114.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Orangelogo from '../../assets/images/Orangelogo.png'
import Knowmorebtn from '../../components/button/Knowmorebtn';


const CaseStudyPromistingResult = () => {
  return (
    <Box
      sx={{
        width: '100%',
        marginTop: '4rem',
        display: 'flex',
        flexDirection:{xs:"column-reverse",sm:"row"},
        padding: {xs:"0rem 1.8rem",sm:"0rem 3rem"},
        marginTop: {xs:"2rem",sm:"4rem"},

      }}
    >
      <Box
        sx={{
          width: {xs:"90%",sm:"48%"},


        }}
      >
        <Box
          sx={{
            width: {xs:'18rem',sm:"32rem"},

          }}
        >
          <LazyLoadImage src={whattodo} effect="blur" width="100%" height="100%" />
        </Box>
      </Box>
      <Box
        sx={{
          width: {xs:"100%",sm:"50%"},
        }}
      >
       
        <Typography
          sx={{
            fontFamily: 'Montserrat',
            fontSize: { xs: '1.4rem', sm: '1.6rem' },
            fontWeight:"500",
            marginTop:"1.2rem",
            

          }}
        >
          Promisting  {' '}
          <span style={{ color: 'rgba(255, 102, 0, 1)' }}>Result</span>
        </Typography>

   

   <Typography sx={{
                fontFamily:"Plus Jakarta Sans",
                marginTop:"1rem",
                color:"rgba(51, 51, 51, 1)",
      }}>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium ,Sed ut spiciatis uste natus  Sed  voluptatem accusantium ,Sed ut spiciatis uste natus.</Typography>
   
   
   
   <Typography sx={{
                fontFamily:"Plus Jakarta Sans",
                marginTop:"1rem",
                color:"rgba(51, 51, 51, 1)",
      }}>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium ,Sed ut spiciatis uste natus  Sed  voluptatem accusantium ,Sed ut spiciatis uste natus.</Typography>
   
   

      </Box>
    </Box>
  );
};

export default CaseStudyPromistingResult;
